<template>
  <component :is="isShow"></component>
</template>
<script>
import First from './index1.vue';
import Last from './index2.vue';
import Cookies from "js-cookie";
export default {
  name: 'week-by-car-num',
  data() {
    return {
      isShow:''
    }
  },
  mounted() {
    if (Cookies.get('userType') == '2'){
      this.isShow=Last
    }else{
      this.isShow=First
    }
  },
  methods: {

  },
}
</script>

<style lang="stylus" scoped>

</style>
